import { Amplify } from "aws-amplify";

let configured = false;

export const initAmplify = () => {
  if (configured) return;
  const rawDomain = import.meta.env.VITE_COGNITO_DOMAIN || "";
  // Amplify constructs the URL as `https://${domain}`. Provide domain WITHOUT scheme.
  const sanitizedDomain = rawDomain
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");
  const rawRedirectSignIn = import.meta.env.VITE_REDIRECT_SIGNIN || "";
  const rawRedirectSignOut = import.meta.env.VITE_REDIRECT_SIGNOUT || "";
  const redirectSignIn = rawRedirectSignIn
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const redirectSignOut = rawRedirectSignOut
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (redirectSignIn.length === 0)
    redirectSignIn.push("http://localhost:5173/");
  if (redirectSignOut.length === 0)
    redirectSignOut.push("http://localhost:5173/");
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
        // region: import.meta.env.VITE_COGNITO_REGION,
        loginWith: {
          oauth: {
            domain: sanitizedDomain,
            scopes: [
              "email",
              "openid",
              "profile",
              // Required to call Cognito user APIs like ChangePassword via Hosted UI tokens
              "aws.cognito.signin.user.admin",
            ],
            redirectSignIn: redirectSignIn,
            redirectSignOut: redirectSignOut,
            responseType: "code",
          },
        },
      },
    },
  });
  const cfg = Amplify.getConfig();
  const hasOauth = Boolean((cfg as any)?.Auth?.Cognito?.loginWith?.oauth);
  if (!hasOauth) {
    console.error(
      "Amplify Auth oauth not configured under Cognito. Check VITE_COGNITO_DOMAIN and redirect URLs.",
      cfg,
    );
  } else {
    const oauthCfg = (cfg as any).Auth.Cognito.loginWith.oauth;
    console.debug("Amplify Auth oauth configured.", oauthCfg);
  }
  configured = true;
};
